import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetOrganisationUsersQueryVariables = Types.Exact<{
  user_id: Types.Scalars["String"];
}>;

export type GetOrganisationUsersQuery = { __typename?: "query_root" } & {
  organisations: Array<
    { __typename?: "organisations" } & Pick<
      Types.Organisations,
      "id" | "name"
    > & {
        organisation_users: Array<
          { __typename?: "organisation_users" } & Pick<
            Types.Organisation_Users,
            "id" | "user_id"
          >
        >;
      }
  >;
};

export const GetOrganisationUsersDocument = gql`
  query GetOrganisationUsers($user_id: String!) {
    organisations {
      id
      name
      organisation_users(where: { user_id: { _eq: $user_id } }) {
        id
        user_id
      }
    }
  }
`;

export function useGetOrganisationUsersQuery(
  options: Omit<
    Urql.UseQueryArgs<GetOrganisationUsersQueryVariables>,
    "query"
  > = {}
) {
  return Urql.useQuery<GetOrganisationUsersQuery>({
    query: GetOrganisationUsersDocument,
    ...options,
  });
}
